export enum OrganizationRegistrationType {
  SITE_OWNER = "siteOwner",
  TENANT_OWNER = "tenantOwner",
  TENANT_INVITED = "tenantInvited",
}
